// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feedback-popup-text-value[data-v-36e72b8d] {\n  font-size: 0.85rem;\n}\n.feedback-popup-text-value p[data-v-36e72b8d] {\n  opacity: 0.5;\n  word-break: break-all;\n  max-height: 80px;\n  overflow-y: auto;\n}\n.feedback-popup-text-value.status-input p[data-v-36e72b8d] {\n  opacity: 1;\n  color: var(--36e72b8d-statusColor_textColor);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
